import CustomerProvider from './CustomerContext';
import Customer from './Customer';


let Index = () => {
    return (
        <CustomerProvider>
            <Customer />
        </CustomerProvider>
    )
}

export default Index;